@for (item of skills; track $index) {
    <div class="iconskill">
        <img src="{{item.image}}" alt="">
        <span>{{item.name}}</span>
    </div>
}

